import {helpdeskQueries} from '@app/dashboard/helpdesk-queries';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {queryClient} from '@common/http/query-client';
import {RouteObject} from 'react-router';

export const chatHistoryRoutes = (): RouteObject[] => {
  return [
    {
      path: 'chat-history',
      shouldRevalidate: shouldRevalidateDatatableLoader,
      lazy: () =>
        import(
          '@app/chat-history/datatable/chat-history-datatable-page'
        ),
      loader: async ({request}) => {
        const url = new URL(request.url);
        if (!url.searchParams.has('viewId')) {
          url.searchParams.append('viewId', 'chat-history');
        }
        return Promise.allSettled([
          queryClient.ensureQueryData(
            helpdeskQueries.conversations.inboxViews,
          ),
          queryClient.ensureQueryData(
            helpdeskQueries.conversations.index(
              Object.fromEntries(url.searchParams),
            ),
          ),
          queryClient.ensureQueryData(
            helpdeskQueries.attributes.normalizedList({
              type: 'conversation',
              for: 'agent',
            }),
          ),
        ]);
      },
    },
  ];
};
